import { render, staticRenderFns } from "./iconHistory.vue?vue&type=template&id=356abb60"
import script from "./iconHistory.vue?vue&type=script&lang=js"
export * from "./iconHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports